<template>
    <div class="c-settings-select">
        <div class="dropdown d-flex align-items-center gap-0-5" :class="{ show : active }">
            <span class="d-md-none d-lg-inline-block">{{ text }}</span>
            <button
                @click.stop="active = !active"
                class="btn btn-text text-primary p-0"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
                <template v-if="selected">{{ selected }}</template>
                <template v-else>{{ options[0].label }}</template>
                <a-icon icon="Dropdown" />
            </button>
            <div
                v-click-outside="closeDropdown"
                v-if="active"
                class="dropdown-menu dropdown-menu-right"
                :class="{ show : active }"
            >
                <button
                    @click="active = !active; sortOption = option.value; selected = option.label"
                    class="dropdown-item text-sm"
                    type="button"
                    v-for="(option, id) in options"
                    :key="id"
                >{{ option.label }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            active: false,
            selected: null
        }
    },
    props: {
        text: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        moduleName: {
            type: String,
            required: false
        }
    },
    methods: {
        selectOption(query, label) {
            this.selected = label
            this.$emit('onChange', query)
        },
        closeDropdown() {
            this.active = !this.active
        }
    },
    computed: {
        sortOption: {
            get() {
                const getter = `get${this.moduleName.charAt(0).toUpperCase() + this.moduleName.slice(1)}GroupBy`
                return this.$store.getters[getter]
            },
            set(value) {
                this.$store.dispatch(`set${this.moduleName.charAt(0).toUpperCase() + this.moduleName.slice(1)}GroupBy`, value).then(() => {
                    this.$store.dispatch(`${this.moduleName}Fetch`)
                })
            }
        }
    }
}
</script>